export default __webpack_public_path__ + "static/media/tplogo.8555432a.png";